import axios from "axios";

export const listNews = (headers, params) => {
  return axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/auth/news`, {
    headers,
    params,
  });
};
